import * as React from "react";
import styled, {css} from "../../styled";
import {shadeAlternate} from "../../styled/helpers";

export const TimelineWrapper = styled("div")`
  background: ${({theme}) => shadeAlternate(0.03, theme.box.background)};
  padding: 45px 60px 20px 60px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
`;

export const TimelineConnector = styled("div")<{ active: boolean; }>`
  height: 3px;
  width: 100%;
  background: ${({theme}) => shadeAlternate(0.2, theme.box.background)};
  ${({active}) => !active ? "" : css`
    background: ${({theme}) => theme.colors.primary};
  `};
`;

export const TimelineMarker = styled("div")<{ active: boolean; current: boolean; }>`
  position: relative;
  height: 14px;
  width: 14px;
  min-width: 14px;
  border-radius: 50%;
  background: ${({theme}) => shadeAlternate(0.2, theme.box.background)};
  ${({active}) => !active ? "" : css`
    background: ${({theme}) => theme.colors.primary};
    .tl-label {
      display: none;
    }
  `};
  ${({current}) => !current ? "" : css`
    .tl-label {
      display: block;
      font-weight: 600;
      font-size: 14px;
    }
  `};
`;

export const TimelineMarkerLabel = styled("div")`
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  width: auto;
  white-space: nowrap;
`;

export interface TimelineStage {
  id: string;
  label: React.ReactNode;
}

interface Props {
  stages: TimelineStage[];
  current: string;
}

export class Timeline extends React.Component<Props> {

  render() {
    const { stages, current } = this.props;
    const currentIndex = stages.findIndex((s) => s.id === current);
    return (
      <TimelineWrapper>
        {stages.map((s, i) => {
          return [
            i === 0 ? null : (
              <TimelineConnector key={`${i}-connector`} active={i <= currentIndex}/>
            ),
            (
              <TimelineMarker key={`${i}-marker`} active={i <= currentIndex} current={i === currentIndex}>
                <TimelineMarkerLabel className="tl-label">
                  {s.label}
                </TimelineMarkerLabel>
              </TimelineMarker>
            ),
          ];
        })}
      </TimelineWrapper>
    );
  }

}
